import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import style from './index.module.scss'

const SearchRow = ({ href, target, children, className, onClick }) => (
  <a
    href={href}
    className={classNames(style.searchRow, className)}
    target={target}
    onClick={onClick}
  >
    {children}
  </a>
)

SearchRow.propTypes = {
  href: PropTypes.string,
  target: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  onClick: PropTypes.func,
}

export default SearchRow
